import Swal from "sweetalert2";

export async function refreshAccessToken() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) throw new Error("Missing refresh token");

  const response = await fetch(`${baseUrl}/v1/auth/refresh-token`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  });

  if (!response.ok) throw new Error("Refresh token thất bại");

  const data = await response.json();
  localStorage.setItem("jwtToken", data.access_token);
  return data.access_token;
}

export async function authFetch(url, options = {}, retry = true) {
  let token = localStorage.getItem("jwtToken");

  // ✅ Nếu chưa có token, thử refresh ngay từ đầu
  if (!token && retry) {
    try {
      token = await refreshAccessToken();
    } catch (err) {
      return handleAuthError("Bạn chưa đăng nhập");
    }
  }

  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  // ✅ Nếu bị 401 hoặc 403, thử refresh token một lần
  if ((res.status === 401 || res.status === 403) && retry) {
    try {
      token = await refreshAccessToken();
      return authFetch(url, options, false); // Retry once
    } catch (err) {
      return handleAuthError("Phiên đăng nhập đã hết hạn");
    }
  }

  return res;
}

function handleAuthError(message) {
  return Swal.fire({
    icon: "warning",
    title: message,
    text: "Vui lòng đăng nhập để tiếp tục.",
    confirmButtonText: "Đăng nhập",
    confirmButtonColor: "#d33",
  }).then(() => {
    localStorage.clear();
    window.location.href = "/login";
    throw new Error(message);
  });
}
